<template lang="pug">
section
  div
    | Being a sponsor is a privilege,
    | since businesses are benefiting
    | from employing migrant workers,
    | and so must ensure the system is not abused.
    | The Home Office wants to be reassured
    | that sponsors can live up to the “significant trust”
    | that the department places in them.
    br
    | The Home Office will check if your business
    | is “honest, dependable and reliable”,
    | and capable of meeting the responsibilities
    | that it expects from sponsors.

  br

  div
    | 🚫
    |
    span
      | Private individuals are not eligible
      | to be recognised as sponsors,
      | unless they are sole traders
      | who wish to sponsor someone
      | to work in their business.
</template>

<script>
export default {
  name: "criteria_general",
};
</script>